import {gql} from 'apollo-angular';

export const GET_GAME_ROUND_PLAYERS = gql`
  query GetGameRoundPlayers($gameId: Int!) {
    getGameRoundPlayers(gameID: $gameId) {
      entries {
        round
        players
      }
      highscore
    }
  }
`;
